import { useState, useEffect } from 'react';
import { LineChart, ResponsiveContainer, Tooltip, Line, XAxis, YAxis, CartesianGrid } from 'recharts';
import { numFormatter } from '../../../../utils/global';
import { dayjs } from '../../../../utils/dayjs-utils';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUpRounded';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDownRounded';
import '../styles/graphs.scss';

const xAxisFormatter = (val) => {
  return dayjs(new Date(val)).format('MMM');
};
const tooltipFormatter = (val) => {
  return dayjs(new Date(val)).format('MMM YY');
};

export default function FollowersGraph({ statsHistory }) {
  const [data, setData] = useState(undefined);

  const calculateFollowerGrowth = () => {
    const currentMonthFollowers = statsHistory[statsHistory.length - 1]?.followers;
    const previousMonthFollowers = statsHistory[statsHistory.length - 2]?.followers;
    const followerChange = currentMonthFollowers - previousMonthFollowers;
    const increasePercent = (followerChange / previousMonthFollowers) * 100;
    return increasePercent.toFixed(2);
  };

  useEffect(() => {
    const d = statsHistory?.map(({ month, followers }) => ({
      name: month,
      value: followers,
    }));
    setData(d);
  }, [statsHistory]);

  if (!data) {
    return null;
  }

  return (
    <div className="demographics-card">
      <h2 style={{ marginBottom: 24 }}>
        Followers{' '}
        <span
          className="follower-change-count"
          style={{ color: calculateFollowerGrowth() > 0 ? 'var(--green)' : 'var(--red)' }}>
          {calculateFollowerGrowth() > 0 ? <ArrowDropUpIcon /> : <ArrowDropDownIcon sx={{ fontSize: 30 }} />}{' '}
          {calculateFollowerGrowth()}% this month
        </span>
      </h2>
      <ResponsiveContainer width="90%" aspect={1.5}>
        <LineChart data={data} height={300} margin={{ left: 0 }}>
          <CartesianGrid />
          <XAxis dataKey="name" tickFormatter={xAxisFormatter} />
          <YAxis tickFormatter={numFormatter} domain={['dataMin - 10000', 'dataMax + 10000']} />
          <Tooltip labelFormatter={tooltipFormatter} formatter={numFormatter} />
          <Line type="monotone" dataKey="value" stroke="#7357e9" strokeWidth={2} activeDot={{ r: 6 }} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
